export const START_UPLOAD = 'START_UPLOAD'
export const START_UPLOAD_SUCCESS = 'START_UPLOAD_SUCCESS'

export const FINISH_UPLOAD = 'FINISH_UPLOAD'
